export const defaultState = () => ({
  breakpoint: 'desktop',
  showModalCarousel: false,
  carouselIndex: 0,
  showVideoTourForm: false,
  showContactModal: false,
  showLeadConfirmationModal: true,
  showModalPreQualified: false,
  scrolled: undefined,
  showImmersiveTourModal: false,
  trackLength: 0,
  hideSavedSearchPopup: true,
  showDealerLocatorModal: false,
  openBoatLoansComponent: 'boat-loans',
  openBoatLoansComponentCounter: 0,
  contactModal: {
    prePopulatedText: ''
  },
  shouldConvertCustomLeadHygieneGoal: false,
});
